document.addEventListener("DOMContentLoaded", () => {
  const tocMount = document.querySelector("[data-toc]");
  if (!tocMount) return;

  // 1) Wo ist der eigentliche Content?
  const content =
    document.querySelector(".rte") ||
    document.querySelector(".article-template__content") ||
    document.querySelector(".main-page") ||
    document.querySelector("main");

  if (!content) return;

  // 2) Welche Überschriften sammeln?
  const headings = content.querySelectorAll("h1, h2, h3, h4");
  if (!headings.length) return;

  const list = document.createElement("ul");
  list.className = "toc-list";

  headings.forEach((h, i) => {
    // Nur echte, sichtbare Überschriften mit Text
    const text = (h.textContent || "").trim();
    if (!text) return;

    if (!h.id) h.id = `toc-h-${i}`;

    const li = document.createElement("li");
    li.className = `toc-${h.tagName.toLowerCase()}`;

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = text;

    li.appendChild(a);
    list.appendChild(li);
  });

  tocMount.innerHTML = "";
  tocMount.appendChild(list);
});
